import { Edit, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { StaffScheduleFormFields } from './StaffScheduleForm';

// Editing an existing mapping only toggles is_primary: the organization / schedule / staff
// identity is locked (changing the target is done by deleting and creating a new mapping).
export const StaffScheduleEdit = () => (
  <Edit redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="userGroupOrganization" />}>
      <MyFormContainer>
        <StaffScheduleFormFields isCreate={false} />
      </MyFormContainer>
    </SimpleForm>
  </Edit>
);

export default StaffScheduleEdit;
